<div class="hf-plans-details-mob" [ngClass]="{'static': !showSlider}">
  <ng-container *ngIf="showSlider">
    <div  class="swiper-container" [swiper]="config">
      <div class="swiper-wrapper">
        <ng-container [ngTemplateOutlet]="planCardRef"></ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!showSlider">
    <ng-container [ngTemplateOutlet]="planCardRef"></ng-container>
  </ng-container>
</div>

<ng-template #planCardRef>
  <div class="hf-plan-card swiper-slide" *ngFor="let item of plans; index as i" [ngClass]="{'h-980': !hide && item.plan === 'plus' && !util.isMobile()}">
    <div class="top-content">
      <div class="header">
        {{item.key}}
        <div class="recommended" *ngIf="recommended === item.plan">
          Recommended Plan For You
        </div>
        <div class="logo">
          <img [src]="i == 0 ? '/assets/images/health-first/hf-essential-plan.svg': '/assets/images/health-first/hf-plus-plan.svg'" alt="icon" />
        </div>
        <div class="desc">
          {{info[i]?.desc}}
        </div>
      </div>
      <div class="hr"></div>
      <div class="benefit-wrapper">
        <div class="benefit-item" [ngClass]="{'mb-14': item.plan === 'essentials' && j === item.benefits.length - 1}" *ngFor="let benefit of item.benefits;index as j">
          <ng-container *ngTemplateOutlet="j === item.benefits.length - 2 && item.plan === 'plus' ? viewMoreRef: imgTitleContentRef; context: {benefit: benefit, item: item, j: j}">
          </ng-container>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="hr"></div>
      <div class="price-section">
        <div class="top-striked">
          Plan Price : <span class="striked">
            {{amountData[item.plan]?.yearly?.plan_price|currency:'INR':'symbol':'0.0-0'}}
          </span>
        </div>
        <div class="main-price">
          <div class="amount">
            {{item.amount| currency:'INR':'symbol':'0.0-0'}}
          </div>
          <div class="duration">
            /{{item.duration}}
          </div>
        </div>
      </div>
      <div class="plan-button-wrapper">
        <app-button label="Buy Now" btnClass="hf-primary-btn" (click)="buyNow(item)"></app-button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #viewMoreRef let-benefit="benefit" let-item="item" let-j="j">
  <button mat-button class="view-more" (click)="hide = !hide" [ngClass]="{'mb20': !hide}">
    <div class="text">
      View {{ hide ? 'More': 'Less'}}
    </div>
    <mat-icon>{{hide ? 'keyboard_arrow_down': 'keyboard_arrow_up'}}</mat-icon>
  </button>
  <ng-container *ngTemplateOutlet="imgTitleContentRef; context: { benefit: benefit, item: item, j:j}"></ng-container>
</ng-template>
<ng-template #imgTitleContentRef let-item="item" let-benefit="benefit" let-j="j">
  <div class="img-wrapper" [hidden]="j > item.benefits.length - 3 && hide && item.plan === 'plus'">
    <img [src]="benefit.favicon" alt="fav icon" />
  </div>
  <div class="content" [hidden]="j > item.benefits.length - 3 && hide && item.plan === 'plus'">
    <div class="title-wrapper">
      <div class="title" [innerHTML]="benefit.title"></div> 
      <div class="last-child" *ngIf="benefit.title.includes('Critical illness')">
        <span class="info-icon">ⓘ</span>
        <span class="optional">optional</span>
      </div>
    </div>
    <div class="desc" [innerHTML]="benefit.about"></div>
  </div>
</ng-template>